import React from 'react'
import {
  Route,
  Switch,
  useRouteMatch,
  RouteComponentProps,
} from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import UserSearch from './search/UserSearch'
import User from './User'

type UserRouteParams = {
  email: string
  id: string
}

export interface UserProps extends RouteComponentProps<UserRouteParams> {}

const UserManager: React.FC = () => {
  const match = useRouteMatch()

  return (
    <ErrorBoundary>
      <Switch>
        <Route
          path={`${match.path}/:email/:id`}
          render={(props: UserProps) => <User {...props} />}
        />
        <Route path={match.path} render={() => <UserSearch />} />
      </Switch>
    </ErrorBoundary>
  )
}

export default UserManager
